module.exports = __webpack_public_path__ + "static/img/map8_relation.3e3d491.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map8_relation.jpg
// module id = qOIi
// module chunks = 1